<template>
    <div class="w-full h-full flex flex-col">
        <custom-simple-select
            v-if="enabled"
            v-model="option"
            label="Estado de orden *"
            placeholder="Diferente a Completado O Cancelado"
            :options="selectOptions"
            @change="onInput"
        />
        <div v-else class="flex flex-col pl-2 pt-2">
            <strong>Estado de orden </strong>
            <span
                class="mt-2 ml-2"
                :class="$data.$ordersStatusesMessageClass[option]"
            >
                {{ $data.$ordersStatusesCodes[itemCurrent] }}
                &nbsp;
                <small>({{ itemCurrent }})</small>
            </span>
        </div>
    </div>
</template>

<script>
import {
    ordersStatusesCodes,
    ordersStatusesMessageClass
} from "@/common/fields/orders-status-codes";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "DeliveryStatusSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "pending",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        $ordersStatusesCodes: ordersStatusesCodes,
        $ordersStatusesMessageClass: ordersStatusesMessageClass
    }),
    computed: {
        selectOptions() {
            return Object.entries(this.$data.$ordersStatusesCodes).map(
                ([key, value]) => ({ label: value, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
